// Pinned seed data — used as fallback when API is down and for server seeding

export const CATEGORIES = ['food', 'stay', 'adventure'];

export const TRAVEL_STYLES = {
  stays: ['hostel', 'hotel', 'airbnb', 'camping', 'couchsurf'],
  eats: ['street food', 'local spots', 'fine dining', 'markets', 'cafes'],
  group: ['solo', 'couple', 'group', 'family'],
  interest: ['adventure', 'relaxation', 'culture', 'foodie', 'nightlife'],
  transport: ['public-transport', 'rideshare', 'rental-car', 'walking'],
};

export const seedUsers = [
  {
    id: 'wheresandres',
    username: 'wheresandres',
    firstName: 'Andres',
    lastName: 'Jaramillo',
    email: 'andres@reroute.app',
    avatarUrl: '/profilepic.jpg',
    bannerUrl: '/berna.jpg',
    bio: 'Shitty pics, cool experiences',
    location: 'Somewhere, probably',
    countriesVisited: ['NO', 'JO', 'TR', 'AR', 'CH'],
    citiesVisited: ['Tromso', 'Petra', 'Istanbul', 'Buenos Aires', 'Bern'],
    travelStyles: ['hostel', 'solo', 'street food', 'adventure', 'public-transport'],
    createdAt: '2024-01-15T00:00:00Z',
  },
  {
    id: 'coco',
    username: 'coco',
    firstName: 'Coco',
    lastName: '',
    email: 'coco@reroute.app',
    avatarUrl: '/coco-profilepic.jpg',
    bannerUrl: '/coco-banner.jpg',
    bio: 'Tacos over everything. LA based, Latin America obsessed.',
    location: 'Los Angeles, CA',
    countriesVisited: ['US', 'MX', 'CO'],
    citiesVisited: ['Los Angeles', 'Mexico City', 'Monterrey', 'Envigado', 'Guatape'],
    travelStyles: ['airbnb', 'couple', 'local spots', 'nightlife', 'rideshare'],
    createdAt: '2024-03-20T00:00:00Z',
  },
  {
    id: 'john_adventures',
    username: 'john_adventures',
    firstName: 'John',
    lastName: 'Kim',
    email: 'john@reroute.app',
    avatarUrl: '/john-profilepic.jpg',
    bannerUrl: '/john-banner.jpg',
    bio: 'Capturing the rich history and culture.',
    location: 'Seoul, Korea',
    countriesVisited: ['TR', 'GR', 'EG'],
    citiesVisited: ['Istanbul', 'Athens', 'Cairo'],
    travelStyles: ['hotel', 'solo', 'culture', 'walking'],
    createdAt: '2024-02-10T00:00:00Z',
  },
  {
    id: 'jane_wanders',
    username: 'jane_wanders',
    firstName: 'Jane',
    lastName: 'Lopez',
    email: 'jane@reroute.app',
    avatarUrl: '/jane-profilepic.jpg',
    bannerUrl: '/jane-banner.jpg',
    bio: 'Savoring the tango and the flavors.',
    location: 'Miami, FL',
    countriesVisited: ['AR', 'BR', 'CO'],
    citiesVisited: ['Buenos Aires', 'Rio de Janeiro', 'Medellin'],
    travelStyles: ['hostel', 'group', 'street food', 'nightlife', 'public-transport'],
    createdAt: '2024-04-05T00:00:00Z',
  },
];

export const seedPosts = [
  {
    id: 'post-1',
    userId: 'wheresandres',
    imageUrl: '/tromso.jpg',
    thumbnailUrl: '/tromso.jpg',
    caption: 'Northern lights hit different when its -20',
    category: 'adventure',
    worthIt: true,
    wouldReturn: true,
    latitude: 69.6496,
    longitude: 18.9560,
    locationName: 'Tromso, Norway',
    countryCode: 'NO',
    exifData: { device: 'iPhone 14', hasGps: true, originalTimestamp: '2024-01-20T22:30:00Z' },
    authenticityScore: 92,
    createdAt: '2024-01-20T23:00:00Z',
  },
  {
    id: 'post-2',
    userId: 'wheresandres',
    imageUrl: '/tromso2.jpg',
    thumbnailUrl: '/tromso2.jpg',
    caption: 'Frozen fjord vibes',
    category: 'adventure',
    worthIt: true,
    wouldReturn: true,
    latitude: 69.6830,
    longitude: 18.9426,
    locationName: 'Tromso, Norway',
    countryCode: 'NO',
    exifData: { device: 'iPhone 14', hasGps: true, originalTimestamp: '2024-01-21T14:00:00Z' },
    authenticityScore: 88,
    createdAt: '2024-01-21T15:00:00Z',
  },
  {
    id: 'post-3',
    userId: 'wheresandres',
    imageUrl: '/petra.jpg',
    thumbnailUrl: '/petra.jpg',
    caption: 'Indiana Jones was right about this place',
    category: 'adventure',
    worthIt: true,
    wouldReturn: false,
    latitude: 30.3285,
    longitude: 35.4444,
    locationName: 'Petra, Jordan',
    countryCode: 'JO',
    exifData: { device: 'iPhone 14', hasGps: true, originalTimestamp: '2024-02-10T10:00:00Z' },
    authenticityScore: 95,
    createdAt: '2024-02-10T11:00:00Z',
  },
  {
    id: 'post-4',
    userId: 'wheresandres',
    imageUrl: '/istanbul.jpg',
    thumbnailUrl: '/istanbul.jpg',
    caption: 'Blue Mosque at golden hour',
    category: 'adventure',
    worthIt: true,
    wouldReturn: true,
    latitude: 41.0054,
    longitude: 28.9768,
    locationName: 'Blue Mosque, Istanbul',
    countryCode: 'TR',
    exifData: { device: 'iPhone 14', hasGps: true, originalTimestamp: '2024-03-05T18:00:00Z' },
    authenticityScore: 90,
    createdAt: '2024-03-05T19:00:00Z',
  },
  {
    id: 'post-5',
    userId: 'wheresandres',
    imageUrl: '/buenos.jpg',
    thumbnailUrl: '/buenos.jpg',
    caption: 'La Boca colors are insane in person',
    category: 'adventure',
    worthIt: true,
    wouldReturn: true,
    latitude: -34.6345,
    longitude: -58.3631,
    locationName: 'La Boca, Buenos Aires',
    countryCode: 'AR',
    exifData: { device: 'iPhone 14', hasGps: true, originalTimestamp: '2024-04-15T16:00:00Z' },
    authenticityScore: 87,
    createdAt: '2024-04-15T17:00:00Z',
  },
  {
    id: 'post-6',
    userId: 'coco',
    imageUrl: '/la.jpg',
    thumbnailUrl: '/la.jpg',
    caption: 'Sunset from Griffith and it actually looked like this',
    category: 'adventure',
    worthIt: true,
    wouldReturn: true,
    latitude: 34.1184,
    longitude: -118.3004,
    locationName: 'Griffith Observatory, LA',
    countryCode: 'US',
    exifData: { device: 'Samsung Galaxy S23', hasGps: true, originalTimestamp: '2024-05-01T19:30:00Z' },
    authenticityScore: 85,
    createdAt: '2024-05-01T20:00:00Z',
  },
  {
    id: 'post-10',
    userId: 'coco',
    imageUrl: '/mexicocity.jfif',
    thumbnailUrl: '/mexicocity.jfif',
    caption: 'CDMX street tacos at 2am hit different than any restaurant',
    category: 'food',
    worthIt: true,
    wouldReturn: true,
    latitude: 19.4326,
    longitude: -99.1332,
    locationName: 'Centro Historico, Mexico City',
    countryCode: 'MX',
    exifData: { device: 'Samsung Galaxy S23', hasGps: true, originalTimestamp: '2024-06-15T02:00:00Z' },
    authenticityScore: 88,
    createdAt: '2024-06-15T02:30:00Z',
  },
  {
    id: 'post-11',
    userId: 'coco',
    imageUrl: '/monterreymx.jpg',
    thumbnailUrl: '/monterreymx.jpg',
    caption: 'Monterrey mountains are no joke. City surrounded by walls of rock',
    category: 'adventure',
    worthIt: true,
    wouldReturn: true,
    latitude: 25.6866,
    longitude: -100.3161,
    locationName: 'Cerro de la Silla, Monterrey',
    countryCode: 'MX',
    exifData: { device: 'Samsung Galaxy S23', hasGps: true, originalTimestamp: '2024-06-18T10:00:00Z' },
    authenticityScore: 90,
    createdAt: '2024-06-18T10:30:00Z',
  },
  {
    id: 'post-12',
    userId: 'coco',
    imageUrl: '/envigadocolombia.png',
    thumbnailUrl: '/envigadocolombia.png',
    caption: 'Envigado feels like the real Colombia. No tourists just life',
    category: 'stay',
    worthIt: true,
    wouldReturn: true,
    latitude: 6.1713,
    longitude: -75.5831,
    locationName: 'Envigado, Colombia',
    countryCode: 'CO',
    exifData: { device: 'Samsung Galaxy S23', hasGps: true, originalTimestamp: '2024-07-02T16:00:00Z' },
    authenticityScore: 86,
    createdAt: '2024-07-02T16:30:00Z',
  },
  {
    id: 'post-13',
    userId: 'coco',
    imageUrl: '/lapiedradelpenol.jpg',
    thumbnailUrl: '/lapiedradelpenol.jpg',
    caption: '740 steps up and my legs are still shaking. Worth every one',
    category: 'adventure',
    worthIt: true,
    wouldReturn: false,
    latitude: 6.2208,
    longitude: -75.1794,
    locationName: 'La Piedra del Penol, Guatape',
    countryCode: 'CO',
    exifData: { device: 'Samsung Galaxy S23', hasGps: true, originalTimestamp: '2024-07-04T11:00:00Z' },
    authenticityScore: 92,
    createdAt: '2024-07-04T11:30:00Z',
  },
  {
    id: 'post-7',
    userId: 'john_adventures',
    imageUrl: '/istanbul.jpg',
    thumbnailUrl: '/istanbul.jpg',
    caption: 'Got lost in the Grand Bazaar for 3 hours',
    category: 'adventure',
    worthIt: true,
    wouldReturn: false,
    latitude: 41.0106,
    longitude: 28.9684,
    locationName: 'Grand Bazaar, Istanbul',
    countryCode: 'TR',
    exifData: { device: 'Pixel 7', hasGps: true, originalTimestamp: '2024-06-12T11:00:00Z' },
    authenticityScore: 91,
    createdAt: '2024-06-12T12:00:00Z',
  },
  {
    id: 'post-8',
    userId: 'jane_wanders',
    imageUrl: '/buenos.jpg',
    thumbnailUrl: '/buenos.jpg',
    caption: 'Best steak of my life was 8 dollars here',
    category: 'food',
    worthIt: true,
    wouldReturn: true,
    latitude: -34.6083,
    longitude: -58.3712,
    locationName: 'San Telmo, Buenos Aires',
    countryCode: 'AR',
    exifData: { device: 'iPhone 15', hasGps: true, originalTimestamp: '2024-07-20T21:00:00Z' },
    authenticityScore: 93,
    createdAt: '2024-07-20T22:00:00Z',
  },
  {
    id: 'post-9',
    userId: 'wheresandres',
    imageUrl: '/sevilla.jpg',
    thumbnailUrl: '/sevilla.jpg',
    caption: 'Flamenco in the streets not the tourist shows',
    category: 'adventure',
    worthIt: true,
    wouldReturn: true,
    latitude: 37.3886,
    longitude: -5.9823,
    locationName: 'Triana, Sevilla',
    countryCode: 'ES',
    exifData: { device: 'iPhone 14', hasGps: true, originalTimestamp: '2024-08-10T23:00:00Z' },
    authenticityScore: 89,
    createdAt: '2024-08-10T23:30:00Z',
  },
];

export const getUserById = (id) => seedUsers.find((u) => u.id === id);
export const getPostsByUserId = (userId) => seedPosts.filter((p) => p.userId === userId);

export const getPostsInBounds = (bounds) => {
  const { north, south, east, west } = bounds;
  return seedPosts.filter(
    (p) =>
      p.latitude >= south &&
      p.latitude <= north &&
      p.longitude >= west &&
      p.longitude <= east
  );
};

export const getPostsByCategory = (category) =>
  category ? seedPosts.filter((p) => p.category === category) : seedPosts;
